import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Tilty from 'react-tilty';
import { Grid, Tooltip, IconButton, Button } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import CheckIcon from '@mui/icons-material/Check';

function shortenAddress(addr = '') {
    return addr.length > 8 ? `${addr.slice(0, 4)}...${addr.slice(-8)}` : addr;
}

function isToday(dateString) {
    const today = new Date();
    const date = new Date(dateString);
    return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
    );
}

const InsurancePoolCards = ({ insurancePools, isLoading, CountdownTimer }) => {
    const navigate = useNavigate();
    const [copiedMint, setCopiedMint] = useState('');
    const [poolsData, setPoolsData] = useState([]);

    useEffect(() => {
        const poolsToRender = isLoading ? new Array(1).fill({}) : insurancePools;
        setPoolsData(poolsToRender);
    }, [insurancePools, isLoading]);

    const handleCopy = (address) => {
        navigator.clipboard.writeText(address);
        setCopiedMint(address);
        setTimeout(() => setCopiedMint(''), 1500);
    };

    return (
        <>
            <style>
                {`
                @keyframes greenFlash {
                    0% { box-shadow: 0 0 10px rgba(0,255,0,0.5); }
                    50% { box-shadow: 0 0 20px rgba(0,255,0,0.9); }
                    100% { box-shadow: 0 0 10px rgba(0,255,0,0.5); }
                }

                .button-link {
                    border: 1px solid #efbc00;
                    padding: 6px 12px;
                    border-radius: 8px;
                    transition: all 0.3s ease;
                    text-decoration: none;
                    display: flex;
                    align-items: center;
                    color: #efbc00;
                }

                .button-link:hover {
                    background-color: #efbc00;
                    color: #000;
                }
                `}
            </style>

            <div className="row" style={{ maxWidth: 1440, margin: '0 auto' }}>
                {poolsData.map((pool, index) => {
                    return (
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex justify-content-center shake-on-hover"
                            key={pool.contract_address || index} style={{ marginBottom: 20 }}
                        >
                            <Tilty max={8} perspective={800}>
                                <div
                                    className={`card ${pool.special == true ? 'highlightToday' : ''}`}
                                    style={{
                                        width: '100%',
                                        minWidth: 450,
                                        minHeight: 470,
                                        padding: 24,
                                        background: 'linear-gradient(to right, rgba(1,101,59,0.12) 60%, rgba(0,63,38,0.12))',
                                        borderRadius: 18,
                                        border: '2px solid #2d9f56',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        transition: 'transform 0.3s ease, background-color 0.3s ease',
                                        cursor: 'default',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.backgroundColor = 'rgba(0, 149, 68, 0.13)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.background = 'linear-gradient(to right, rgba(1,101,59,0.12) 60%, rgba(0,63,38,0.12))';
                                    }}
                                >

                                    <Grid container alignItems="center" justifyContent="space-between">
                                        <Grid item>
                                            <h5 style={{ color: '#fff', fontSize: 18, margin: 0 }}>{pool.token_symbol}</h5>
                                            <div style={{ color: '#aaa', fontSize: 14 }}>{pool.token_name}</div>
                                        </Grid>
                                        {!isLoading && (
                                            <Grid item style={{ textAlign: 'right' }}>
                                                {pool.token_status === 'pending' ? (
                                                    <div style={{ color: '#ffeb3b', fontSize: 16 }}>
                                                        <CountdownTimer
                                                            targetDate={pool.launch_date}
                                                            fontSize={15}
                                                            title="Launches in: "
                                                            endTitle=""
                                                        />
                                                    </div>
                                                ) : (
                                                    <div style={{ color: '#aaa', fontSize: 14 }}>
                                                        {pool.holders} {isLoading ? "" : "Holders"}
                                                    </div>
                                                )}
                                                <div style={{ color: '#4caf50', fontSize: 13, marginTop: 4 }}>
                                                    Coverage period: {pool.coverage_period}
                                                </div>
                                            </Grid>
                                        )}

                                    </Grid>



                                    <div
                                        style={{
                                            width: '100%',
                                            height: '4px',
                                            marginTop: 2,
                                            marginBottom: 2,
                                            background: 'linear-gradient(to right, #67d36d, transparent)',
                                            marginBottom: '16px',
                                            borderRadius: '2px',
                                        }}
                                    />
                                    <Grid container spacing={2} mt={1}>
                                        <Grid item xs={6}>
                                            <img
                                                src={pool.cover_image && require(`../../assets/images/logo/insurance/${pool.cover_image}.png`)}
                                                alt={pool.token_symbol}
                                                className="shake-image"
                                                style={{
                                                    width: '100%',
                                                    height: 'auto',
                                                    borderRadius: 10,
                                                    maxWidth: 120,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', rowGap: 10 }}>
                                            {isLoading ? (
                                                <>
                                                    <div style={{ height: 24, backgroundColor: '#333', borderRadius: 4 }} />
                                                    <div style={{ height: 18, backgroundColor: '#333', borderRadius: 4 }} />
                                                    <div style={{ height: 18, backgroundColor: '#333', borderRadius: 4 }} />
                                                    <div style={{ height: 18, backgroundColor: '#333', borderRadius: 4 }} />
                                                    <div style={{ height: 18, backgroundColor: '#333', borderRadius: 4 }} />
                                                </>
                                            ) : (
                                                <>
                                                    {pool.token_status === 'pending' && (
                                                        <div style={{ fontSize: 24, color: '#ffeb3b', textAlign: 'center', marginBottom: 6, marginRight: 20 }}>
                                                            <CountdownTimer targetDate={pool.launch_date} fontSize={18} title="Starts in: " endTitle="" />
                                                        </div>
                                                    )}
                                                    <div style={{ color: '#ddd', fontSize: 13 }}>
                                                        🥇 Top 50 → <span style={{ color: '#efbc00' }}>{pool.insurance_bonus_tiers?.top_50}</span>
                                                    </div>
                                                    <div style={{ color: '#ddd', fontSize: 13 }}>
                                                        🥈 Top 100 → <span style={{ color: '#efbc00' }}>{pool.insurance_bonus_tiers?.top_100}</span>
                                                    </div>
                                                    <div style={{ color: '#ddd', fontSize: 13 }}>
                                                        🥉 Top 350 → <span style={{ color: '#efbc00' }}>{pool.insurance_bonus_tiers?.top_350}</span>
                                                    </div>
                                                    <div style={{ color: '#ddd', fontSize: 13 }}>
                                                        ✅ Others → <span style={{ color: '#efbc00' }}>{pool.insurance_bonus_tiers?.everyone_else}</span>
                                                    </div>
                                                </>
                                            )}
                                        </Grid>
                                    </Grid>
                                    {!isLoading && (
                                        <>
                                            <div style={{ marginTop: 16, fontSize: 16, color: '#ccc', wordBreak: 'break-all' }}>
                                                {pool.token_status === 'pending' ? (
                                                    <>  <strong>CA:</strong> Launching on pump.fun soon... </>
                                                ) : (
                                                    <>
                                                        <strong>CA:</strong> {shortenAddress(pool.contract_address)}{' '}
                                                        <Tooltip title="Copy">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleCopy(pool.contract_address)}
                                                                sx={{ color: '#efbc00', padding: 0, marginLeft: 1 }}
                                                            >
                                                                {copiedMint === pool.contract_address ? (
                                                                    <CheckIcon fontSize="small" />
                                                                ) : (
                                                                    <FileCopyIcon fontSize="small" />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {isLoading ? (
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: 8 }}>
                                            <div style={{ height: 36, width: 120, backgroundColor: '#333', borderRadius: 8 }} />
                                            <div style={{ height: 36, width: 120, backgroundColor: '#333', borderRadius: 8 }} />
                                            <div style={{ height: 36, width: 120, backgroundColor: '#333', borderRadius: 8 }} />
                                        </div>
                                    ) : (
                                        <>
                                            <div style={{
                                                marginTop: 24,
                                                display: 'flex',
                                                justifyContent: 'flex-start',
                                                gap: 8,
                                                flexWrap: 'wrap'
                                            }}>
                                                <Button
                                                    component="a"
                                                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                                                        `Check out ${pool.token_name} (${pool.token_symbol}) - ${pool.token_status === 'active' ? 'Now live on pump.fun!' : 'Launching soon!'}\n\n` +
                                                        `${pool.token_status === 'active' ? `Trade here: https://pump.fun/${pool.contract_address}\n\n` : ''}` +
                                                        `🚀 Powered by Oscar Trash 2 Gold ecosystem\n` +
                                                        `#Memecoin #DeFi #PumpFun`
                                                    )}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={
                                                        <img
                                                            src={require('../../assets/images/logo/twitter.png')}
                                                            alt="X/Twitter"
                                                            style={{ width: 25, height: 25 }}
                                                        />
                                                    }
                                                    sx={{
                                                        color: '#fff',
                                                        borderColor: 'rgba(255,255,255,0.3)',
                                                        borderRadius: '12px',
                                                        padding: '6px 12px',
                                                        '&:hover': {
                                                            borderColor: '#fff',
                                                            backgroundColor: 'rgba(255,255,255,0.05)'
                                                        },
                                                    }}
                                                >
                                                    Share
                                                </Button>
                                                <Button
                                                    component="a"
                                                    href="https://t.me/oscartrash2gold"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={
                                                        <img
                                                            src={require('../../assets/images/logo/telegram.png')}
                                                            alt="Telegram"
                                                            style={{ width: 20, height: 20 }}
                                                        />
                                                    }
                                                    sx={{
                                                        color: '#fff',
                                                        borderColor: 'rgba(255,255,255,0.3)',
                                                        borderRadius: '12px',
                                                        padding: '6px 12px',
                                                        '&:hover': {
                                                            borderColor: '#fff',
                                                            backgroundColor: 'rgba(255,255,255,0.05)'
                                                        },
                                                    }}
                                                >
                                                </Button>
                                                <Button
                                                    component="a"
                                                    href={`https://x.com/oscartrash2gold`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={
                                                        <img
                                                            src={require('../../assets/images/logo/twitter.png')}
                                                            alt="X/Twitter"
                                                            style={{ width: 25, height: 25 }}
                                                        />
                                                    }
                                                    sx={{
                                                        color: '#fff',
                                                        borderColor: 'rgba(255,255,255,0.3)',
                                                        borderRadius: '12px',
                                                        padding: '6px 12px',
                                                        '&:hover': {
                                                            borderColor: '#fff',
                                                            backgroundColor: 'rgba(255,255,255,0.05)'
                                                        },
                                                    }}
                                                >
                                                </Button>
                                                {pool.token_status === 'active' && pool.contract_address && (
                                                    <Button
                                                        component="a"
                                                        href={`https://pump.fun/${pool.contract_address}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        variant="outlined"
                                                        size="small"
                                                        startIcon={
                                                            <img
                                                                src={require('../../assets/images/logo/pump-fun.png')}
                                                                alt="pump.fun"
                                                                style={{ width: 18, height: 18 }}
                                                            />
                                                        }
                                                        sx={{
                                                            color: '#fff',
                                                            borderColor: 'rgba(255,255,255,0.3)',
                                                            borderRadius: '12px',
                                                            padding: '6px 12px',
                                                            '&:hover': {
                                                                borderColor: '#fff',
                                                                backgroundColor: 'rgba(255,255,255,0.05)'
                                                            },
                                                        }}
                                                    >
                                                        pump.fun
                                                    </Button>
                                                )}

                                            </div>
                                        </>
                                    )}
                                </div>
                            </Tilty>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default InsurancePoolCards;
